// Application Configuration
export const APP_CONFIG = {
  // Set to false to disable user registrations (development mode)
  ALLOW_SIGNUPS: false,

  // Development mode settings
  DEVELOPMENT_MODE: true,

  // Admin settings
  ADMIN_EMAILS: [
    "admin@ftam.com",
    "owner@ftam.com",
    "ryandymock@gmail.com", // Your admin email
  ],

  // Feature flags
  FEATURES: {
    NEWSLETTER_SIGNUP: true,
    CONTACT_FORM: true,
    ADMIN_DASHBOARD: true,
  },

  // Messages
  MESSAGES: {
    SIGNUP_DISABLED:
      "New user registrations are temporarily disabled while we're working on improvements to the platform.",
    DEVELOPMENT_MODE: "🚧 Development Mode",
  },
};

export default APP_CONFIG;
